// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable */

//You-Dont-Need-Lodash-Underscore Manifest

//https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore

/**
 * Creates a debounced function that delays invoking func until after wait milliseconds have elapsed since
 * the last time the debounced function was invoked.
 *
 * source: https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_debounce
 *
 * @param func The function to debounce.
 * @param wait The number of milliseconds to delay.
 * @return Returns the new debounced function.
 */
export const debounce = (func, wait, immediate = false) => {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }, wait);
    if (immediate && !timeout) func.apply(context, args);
  };
};

/**
 * Checks if value is an empty object or collection.
 *
 * Note: that the Native version does not support evaluating a Set or a Map
 *
 * source: https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_isempty
 *
 * @param value The value to inspect.
 * @return Returns true if value is empty, else false.
 */
export const isEmpty = obj =>
  [Object, Array].includes((obj || {}).constructor) &&
  !Object.entries(obj || {}).length;

/**
 *
 * Gets the value at path of object. Note: If provided path does not exist inside the object js will generate error.
 *
 * source: https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_get
 *
 * @param object The object to query.
 * @param path The path of the property to get.
 * @param defaultValue The value returned if the resolved value is undefined.
 * @return Returns the resolved value.
 */
export const get = (obj, path, defaultValue = undefined) => {
  const travel = regexp =>
    String.prototype.split
      .call(path, regexp)
      .filter(Boolean)
      .reduce(
        (res, key) => (res !== null && res !== undefined ? res[key] : res),
        obj,
      );
  const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/);
  return result === undefined || result === obj ? defaultValue : result;
};
